import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { RefreshIcon } from 'tdesign-icons-react';
import { Loading } from 'tdesign-react';

import { useInfiniteScrollRender } from '@/hooks/useInfiniteScrollRender';
import {
  ILibrarySearchValue,
  ResourceTabType,
  UserResourceType,
} from '@/interface/library';
import Empty from '@/pages/mission/info/card/event/empty';
import { UserResourceDetail } from '@/services/library';

import styles from './index.module.less';
import AudioItem from './item/audio';
import ImageItem from './item/image';
import SpineItem from './item/spine';
import VideoItem from './item/video';

interface IProps {
  hasNext: boolean;
  list: UserResourceDetail[];
  checkValue: string[];
  loading: boolean;
  failed: boolean;
  disabled: boolean;
  type: UserResourceType | undefined;
  searchValue: ILibrarySearchValue;
  onCheckedChange: (checked: string) => void;
  getNextPage: () => void;
  updateResource: (value: UserResourceDetail) => void;
  reNameCallback: (info: UserResourceDetail) => void
}

const LibraryList: React.FC<IProps> = (props) => {
  const {
    hasNext = false,
    list = [],
    checkValue = [],
    loading,
    failed,
    type,
    searchValue,
    disabled,
    onCheckedChange,
    getNextPage,
    updateResource,
    reNameCallback,
  } = props;

  const { containerRef, wrapperRef } = useInfiniteScrollRender({
    currentList: list || [],
    hasNextPage: hasNext || false,
    getNextPage,
  });

  const handleCheckedChange = (check: boolean, id: string) => {
    if (check) {
      onCheckedChange(id);
    } else {
      onCheckedChange(type ? '' : id);
    }
  };

  if (loading) {
    return (
      <div className={styles.empty}>
        <Loading loading={loading} />
      </div>
    );
  }

  if (!list?.length || (
    searchValue?.tabType === ResourceTabType.TAB_TYPE_NOVA
    && searchValue?.type !== UserResourceType.RESOURCE_TYPE_AUDIO)
  ) {
    return (
      <div className={styles.empty}>
        <Empty text="暂无素材" />
      </div>
    );
  }

  const height = document.getElementById('libraryContentContendClient')?.clientHeight || 857;

  return (
    <div ref={containerRef} className={styles.listContainer} id="scrollableItemsPanel" >
      <InfiniteScroll
        height={height - 57}
        hasMore={hasNext || false}
        dataLength={list.length}
        loader={
          <div className={classNames(styles.loadingWrapper)}>
            {failed ? <div className={styles.failed} onClick={getNextPage}>资源加载失败，点击重试 <RefreshIcon /></div> : <Loading size="small" text="资源加载中..." />}
          </div>
        }
        scrollableTarget="scrollableItemsPanel"
        next={getNextPage}
      >
        <div className={styles.listWrapper} ref={wrapperRef}>
          {list?.map((e, index) => {
            if (searchValue?.type && e?.type && e?.type !== searchValue?.type) {
              return null;
            }

            const ids = list?.filter(e => e?.url).map(e => e?.resourceId) as string[];
            const res = ids?.filter(x => checkValue?.includes(x));
            const id = e?.resourceId || '';
            const checked = res?.includes(id);
            const name = e?.resourceName || '';

            const urls = list.filter(e => e?.url).map(e => e?.url) as string[];
            const url = e?.url || '';

            if (searchValue.type === UserResourceType.RESOURCE_TYPE_SPINE) {
              return (
                <div key={index} className={styles.item}>
                  <SpineItem
                    resourceName={name}
                    checked={checked}
                    value={e}
                    handleCheckedChange={check => handleCheckedChange(check, id)}
                    disabled={disabled}
                    updateResource={updateResource}
                    reNameCallback={reNameCallback}
                  />
                </div>
              );
            }
            if (searchValue.type === UserResourceType.RESOURCE_TYPE_IMAGE) {
              return (
                <div key={index} className={styles.item}>
                  <ImageItem
                    type={type}
                    index={index}
                    url={url}
                    resourceName={name}
                    checked={checked}
                    urls={urls}
                    value={e}
                    disabled={disabled}
                    updateResource={updateResource}
                    handleCheckedChange={check => handleCheckedChange(check, id)
                    }
                    reNameCallback={reNameCallback}
                  />
                </div>
              );
            }
            if (searchValue.type === UserResourceType.RESOURCE_TYPE_AUDIO) {
              return (
                <div key={index} className={styles.item} >
                  <AudioItem
                    type={type}
                    index={index}
                    url={url}
                    resourceName={name}
                    checked={checked}
                    handleCheckedChange={check => handleCheckedChange(check, id)}
                    value={e}
                    disabled={disabled}
                    updateResource={updateResource}
                    reNameCallback={reNameCallback}
                  />
                </div>
              );
            }
            if (searchValue.type === UserResourceType.RESOURCE_TYPE_VIDEO) {
              return (
                <div key={index} className={styles.item}>
                  <VideoItem
                    type={type}
                    index={index}
                    url={url}
                    resourceName={name}
                    checked={checked}
                    handleCheckedChange={check => handleCheckedChange(check, id)}
                    value={e}
                    disabled={disabled}
                    updateResource={updateResource}
                    reNameCallback={reNameCallback}
                  />
                </div>
              );
            }
          })}
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default LibraryList;
